/*
 * בול פרקט - מנוע מחשבון פריסת מסגרות קיר (שיחה 06 במעבר לשופיפיי)
 * הלוגיקה מועתקת אחד לאחד מסניפט 43 באתר הישן: 20 פריסות, קרף 3 מ"מ,
 * אריזה גלובלית על כל הקירות (First-Fit מול Best-Fit), קיטים, פינות וחיתוך.
 * אין כאן שום ממשק. הקובץ עובד גם בדפדפן (window.BPFrameEngine) וגם ב-node לבדיקות.
 */
(function (root) {
  'use strict';

  var KERF = 0.3;

  /* ================= פריסות ================= */
  function G(x, y, w, h, cols, rows, gap, gy) {
    if (!gy) { gy = gap; }
    var cw = (w - (cols - 1) * gap) / cols, ch = (h - (rows - 1) * gy) / rows, out = [], i, j;
    if (cw <= 4 || ch <= 4 || !isFinite(cw) || !isFinite(ch)) { return []; }
    for (j = 0; j < rows; j++) { for (i = 0; i < cols; i++) { out.push({ x: x + i * (cw + gap), y: y + j * (ch + gy), w: cw, h: ch }); } }
    return out;
  }
  function box(o, W, H) { return { x: o.side, y: o.bottom, w: W - 2 * o.side, h: H - o.top - o.bottom }; }
  function inset(r, d) { return { x: r.x + d, y: r.y + d, w: r.w - 2 * d, h: r.h - 2 * d }; }
  function ok(r) { return r && r.w > 4 && r.h > 4; }
  function asym3b(b, o, wideCenter) {
    var rt = Math.max(1.1, o.ratio || 2), t = b.w - 2 * o.gap, s, c;
    if (wideCenter) { s = t / (2 + rt); c = s * rt; } else { c = t / (1 + 2 * rt); s = c * rt; }
    if (s <= 4 || c <= 4 || b.h <= 4) { return []; }
    return [{ x: b.x, y: b.y, w: s, h: b.h }, { x: b.x + s + o.gap, y: b.y, w: c, h: b.h }, { x: b.x + s + o.gap + c + o.gap, y: b.y, w: s, h: b.h }];
  }
  function asym3(W, H, o, wideCenter) { return asym3b(box(o, W, H), o, wideCenter); }
  function gU(o) { return (o.gapu == null ? o.gap / 2 : +o.gapu); }
  function gD(o) { return (o.gapd == null ? o.gap / 2 : +o.gapd); }
  function upBox(W, H, o) { var gu = gU(o); return { x: o.side, y: o.rail + gu, w: W - 2 * o.side, h: H - o.top - o.rail - gu }; }
  function railLine(W, o) { return [{ x1: 0, y1: o.rail, x2: W, y2: o.rail }]; }
  function splitRows(rects, H, o) {
    var out = [], i, r, lo, up, gu = gU(o), gd = gD(o);
    for (i = 0; i < rects.length; i++) {
      r = rects[i];
      lo = { x: r.x, y: r.y, w: r.w, h: o.rail - gd - r.y };
      up = { x: r.x, y: o.rail + gu, w: r.w, h: (r.y + r.h) - (o.rail + gu) };
      if (ok(lo)) { out.push(lo); }
      if (ok(up)) { out.push(up); }
    }
    return out;
  }
  function stripes(o, W, yTop) {
    var n = Math.max(2, o.stripes), i, l = [], aw = W - 2 * o.side, st = aw / (n - 1);
    for (i = 0; i < n; i++) { l.push({ x1: o.side + i * st, y1: o.bottom, x2: o.side + i * st, y2: yTop }); }
    return l;
  }

  var LAY = [
    { id: 'row', n: 'שורת מסגרות לאורך הקיר', p: ['side', 'top', 'bottom', 'gap', 'cols'], f: function (W, H, o) {
      var b = box(o, W, H); return { r: G(b.x, b.y, b.w, b.h, o.cols, 1, o.gap), l: [] }; } },
    { id: 'railbelow', n: 'קרניז אמצע קיר ומסגרות מתחתיו', p: ['side', 'bottom', 'gap', 'cols', 'rail'], f: function (W, H, o) {
      return { r: G(o.side, o.bottom, W - 2 * o.side, o.rail - o.gap - o.bottom, o.cols, 1, o.gap), l: railLine(W, o) }; } },
    { id: 'railabove', n: 'קרניז אמצע קיר ומסגרות מעליו', p: ['side', 'top', 'gap', 'gapu', 'cols', 'rail'], f: function (W, H, o) {
      var b = upBox(W, H, o); return { r: G(b.x, b.y, b.w, b.h, o.cols, 1, o.gap), l: railLine(W, o) }; } },
    { id: 'railaboveWide', n: 'קרניז אמצע ומסגרות מעליו, רחבה במרכז', p: ['side', 'top', 'gap', 'gapu', 'ratio', 'rail'], f: function (W, H, o) {
      return { r: asym3b(upBox(W, H, o), o, true), l: railLine(W, o) }; } },
    { id: 'wideCenter', n: 'רחבה במרכז ושתיים צרות בצדדים', p: ['side', 'top', 'bottom', 'gap', 'ratio'], f: function (W, H, o) {
      return { r: asym3(W, H, o, true), l: [] }; } },
    { id: 'wideCenter2', n: 'רחבה במרכז ושתיים צרות, בשתי שורות', p: ['side', 'top', 'bottom', 'gap', 'gapu', 'gapd', 'ratio', 'rail'], f: function (W, H, o) {
      return { r: splitRows(asym3(W, H, o, true), H, o), l: [] }; } },
    { id: 'wideCenter2rail', n: 'רחבה במרכז ושתיים צרות, בשתי שורות עם קרניז אמצע', p: ['side', 'top', 'bottom', 'gap', 'gapu', 'gapd', 'ratio', 'rail'], f: function (W, H, o) {
      return { r: splitRows(asym3(W, H, o, true), H, o), l: railLine(W, o) }; } },
    { id: 'tworows', n: 'שתי שורות מסגרות בלי קרניז מפריד', p: ['side', 'top', 'bottom', 'gap', 'gapu', 'gapd', 'cols', 'rail'], f: function (W, H, o) {
      var b = box(o, W, H); return { r: splitRows(G(b.x, b.y, b.w, b.h, o.cols, 1, o.gap), H, o), l: [] }; } },
    { id: 'narrowCenter', n: 'צרה במרכז ושתיים רחבות בצדדים', p: ['side', 'top', 'bottom', 'gap', 'ratio'], f: function (W, H, o) {
      return { r: asym3(W, H, o, false), l: [] }; } },
    { id: 'pair', n: 'זוג לא סימטרי - רחבה וצרה', p: ['side', 'top', 'bottom', 'gap', 'ratio'], f: function (W, H, o) {
      var b = box(o, W, H), rt = Math.max(1.1, o.ratio || 2), t = b.w - o.gap, nw = t / (1 + rt), wd = nw * rt;
      if (nw <= 4 || b.h <= 4) { return { r: [], l: [] }; }
      return { r: [{ x: b.x, y: b.y, w: wd, h: b.h }, { x: b.x + wd + o.gap, y: b.y, w: nw, h: b.h }], l: [] }; } },
    { id: 'wainscot', n: 'בואזרי מלא - שני קרניזים ומסגרות ביניהם', p: ['side', 'bottom', 'gap', 'cols', 'rail'], f: function (W, H, o) {
      return { r: G(o.side, o.bottom + o.gap, W - 2 * o.side, o.rail - o.bottom - 2 * o.gap, o.cols, 1, o.gap),
        l: [{ x1: 0, y1: o.bottom, x2: W, y2: o.bottom }, { x1: 0, y1: o.rail, x2: W, y2: o.rail }] }; } },
    { id: 'fullheight', n: 'מסגרות מרצפה לתקרה', p: ['side', 'gap', 'cols'], f: function (W, H, o) {
      return { r: G(o.side, 8, W - 2 * o.side, H - 16, o.cols, 1, o.gap), l: [] }; } },
    { id: 'railboth', n: 'מסגרות משני צידי קרניז האמצע', p: ['side', 'top', 'bottom', 'gap', 'gapu', 'gapd', 'cols', 'rail'], f: function (W, H, o) {
      var gu = gU(o), gd = gD(o),
        a = G(o.side, o.bottom, W - 2 * o.side, o.rail - gd - o.bottom, o.cols, 1, o.gap),
        b = G(o.side, o.rail + gu, W - 2 * o.side, H - o.top - o.rail - gu, o.cols, 1, o.gap);
      return { r: a.concat(b), l: railLine(W, o) }; } },
    { id: 'batten', n: 'פסים אנכיים עם קרניז אופקי מעליהם', p: ['side', 'bottom', 'stripes', 'rail'], f: function (W, H, o) {
      var l = stripes(o, W, o.rail); l.push({ x1: 0, y1: o.rail, x2: W, y2: o.rail }); return { r: [], l: l }; } },
    { id: 'grid', n: 'רשת מסגרות - שורות ועמודות', p: ['side', 'top', 'bottom', 'gap', 'gapv', 'cols', 'rows'], f: function (W, H, o) {
      var b = box(o, W, H); return { r: G(b.x, b.y, b.w, b.h, o.cols, o.rows, o.gap, o.gapv), l: [] }; } },
    { id: 'gridstripes', n: 'רשת פסים אנכיים ואופקיים', p: ['side', 'top', 'bottom', 'cols', 'rows'], f: function (W, H, o) {
      var l = [], i, x1 = o.side, x2 = W - o.side, y1 = o.bottom, y2 = H - o.top;
      var nv = Math.max(2, o.cols + 1), nh = Math.max(2, o.rows + 1);
      if (x2 - x1 <= 4 || y2 - y1 <= 4) { return { r: [], l: [] }; }
      var sv = (x2 - x1) / (nv - 1), sh = (y2 - y1) / (nh - 1);
      for (i = 0; i < nv; i++) { l.push({ x1: x1 + i * sv, y1: y1, x2: x1 + i * sv, y2: y2 }); }
      for (i = 0; i < nh; i++) { l.push({ x1: x1, y1: y1 + i * sh, x2: x2, y2: y1 + i * sh }); }
      return { r: [], l: l }; } },
    { id: 'single', n: 'מסגרת אחת גדולה', p: ['side', 'top', 'bottom'], f: function (W, H, o) {
      var b = box(o, W, H); return { r: ok(b) ? [b] : [], l: [] }; } },
    { id: 'double', n: 'מסגרת בתוך מסגרת', p: ['side', 'top', 'bottom', 'inset'], f: function (W, H, o) {
      var b = box(o, W, H), i = inset(b, o.inset); return { r: [b, i].filter(ok), l: [] }; } },
    { id: 'vstripes', n: 'פסים אנכיים', p: ['side', 'top', 'bottom', 'stripes'], f: function (W, H, o) {
      return { r: [], l: stripes(o, W, H - o.top) }; } },
    { id: 'rail', n: 'קרניז אמצע קיר בלבד', p: ['rail'], f: function (W, H, o) {
      return { r: [], l: railLine(W, o) }; } }
  ];
  var LAYMAP = {}; LAY.forEach(function (l) { LAYMAP[l.id] = l; });

  var FLD = {
    side: { l: 'מרווח מהצדדים (ס"מ)', min: 0, max: 200 },
    top: { l: 'מרווח מהתקרה (ס"מ)', min: 0, max: 200 },
    bottom: { l: 'מרווח מהרצפה (ס"מ)', min: 0, max: 250 },
    gap: { l: 'מרווח בין המסגרות (ס"מ)', min: 1, max: 100 },
    gapu: { l: 'מרווח אנכי למעלה - מעל קו ההפרדה (ס"מ)', min: 0, max: 120 },
    gapd: { l: 'מרווח אנכי למטה - מתחת לקו ההפרדה (ס"מ)', min: 0, max: 120 },
    gapv: { l: 'מרווח אנכי בין השורות (ס"מ)', min: 1, max: 120 },
    cols: { l: 'מספר עמודות', min: 1, max: 12 },
    rows: { l: 'מספר שורות', min: 1, max: 8 },
    rail: { l: 'גובה קרניז האמצע מהרצפה (ס"מ)', min: 20, max: 300 },
    target: { l: 'רוחב מסגרת מבוקש (ס"מ)', min: 20, max: 300 },
    inset: { l: 'מרווח בין המסגרות הפנימיות (ס"מ)', min: 2, max: 60 },
    stripes: { l: 'מספר פסים', min: 2, max: 20 },
    ratio: { l: 'פי כמה הרחבה גדולה מהצרה', min: 1.2, max: 5, st: 0.1 }
  };

  function newWall() {
    return { W: 400, H: 270, lay: 'row', o: { side: 20, top: 25, bottom: 25, gap: 12, gapu: 8, gapd: 8, gapv: 12, cols: 3, rows: 2, rail: 100, target: 75, inset: 8, stripes: 4, ratio: 2 } };
  }

  /* ================= חישוב ================= */
  function cm(n) { return (Math.round(n * 10) / 10).toFixed(1); }
  function rodOf(S) { return S.mold ? S.mold.rod : 240; }

  /*
   * צלע ארוכה ממוט מתחלקת לכמה חלקים. שתי שיטות, ו-calcAll בוחרת את זו שצריכה פחות מוטות:
   *  eq    - חלקים שווים (כמו באתר הישן). התפרים סימטריים.
   *  smart - מוטות שלמים, ומה שנשאר בחלק אחד קצר (לפחות MINP ס"מ), שנכנס לשארית של מוט אחר.
   * מספר התפרים זהה בשתי השיטות. בחלק של צלע מסגרת רק קצה אחד ב-45 מעלות, והחיבור באמצע ישר.
   */
  var MINP = 40;
  function addP(arr, len, ang, lbl, rod, mode) {
    if (len <= 0) { return; }
    var max = rod - 0.5;
    if (len <= max) { arr.push({ len: len, ang: ang, lbl: lbl }); return; }
    var parts = Math.ceil(len / max), lens = [], k;
    if (mode && typeof mode === 'object') { mode = mode[cm(len)] || 'eq'; }
    if (mode === 'smart') {
      for (k = 0; k < parts - 1; k++) { lens.push(max); }
      var rem = len - max * (parts - 1);
      if (rem < MINP) { lens[lens.length - 1] = max + rem - MINP; rem = MINP; }
      lens.push(rem);
    } else {
      for (k = 0; k < parts; k++) { lens.push(len / parts); }
    }
    lens.forEach(function (l, i) {
      var a = ang === '45/45' ? ((i === 0 || i === parts - 1) ? '45/ישר' : 'ישר') : ang;
      arr.push({ len: l, ang: a, lbl: lbl + ' (חלק ' + (i + 1) + ' מתוך ' + parts + ')' });
    });
  }
  function geoOf(w) {
    var def = LAYMAP[w.lay] || LAY[0];
    try { return def.f(+w.W, +w.H, w.o); } catch (e) { return { r: [], l: [] }; }
  }
  function wallCalc(w, rod, mode) {
    var g = geoOf(w), P = [];
    g.r.forEach(function (rc, i) {
      var t = 'מסגרת ' + (i + 1);
      addP(P, rc.w, '45/45', t + ' - צלע עליונה', rod, mode);
      addP(P, rc.w, '45/45', t + ' - צלע תחתונה', rod, mode);
      addP(P, rc.h, '45/45', t + ' - צלע ימין', rod, mode);
      addP(P, rc.h, '45/45', t + ' - צלע שמאל', rod, mode);
    });
    g.l.forEach(function (ln, i) {
      var L = Math.sqrt(Math.pow(ln.x2 - ln.x1, 2) + Math.pow(ln.y2 - ln.y1, 2));
      addP(P, L, 'ישר', 'פס ' + (i + 1), rod, mode);
    });
    return { geo: g, pieces: P };
  }
  function packOnce(pieces, rod, best) {
    var bins = [], i, b;
    pieces.forEach(function (p) {
      b = null;
      for (i = 0; i < bins.length; i++) {
        if (bins[i].rem >= p.len + KERF - 0.001) {
          if (!best) { b = bins[i]; break; }
          if (!b || bins[i].rem < b.rem) { b = bins[i]; }
        }
      }
      if (!b) { b = { rem: rod, items: [] }; bins.push(b); }
      b.items.push(p); b.rem -= (p.len + KERF);
    });
    return bins;
  }
  function pack(pieces, rod) {
    var arr = pieces.slice().sort(function (a, b) { return b.len - a.len; });
    var ff = packOnce(arr, rod, false), bf = packOnce(arr, rod, true);
    return bf.length < ff.length ? bf : ff;
  }
  function binTxt(b, multi) {
    return b.items.map(function (x) { return cm(x.len) + (multi ? ' (קיר ' + x.wall + ')' : ''); }).join(' + ');
  }
  function calcMode(S, mode) {
    var rod = rodOf(S), all = [], per = [], frames = 0, mm = 0, solo = 0, shared = 0;
    S.walls.forEach(function (w, i) {
      var c = wallCalc(w, rod, mode);
      per.push(c);
      frames += c.geo.r.length;
      c.pieces.forEach(function (p) { all.push({ len: p.len, ang: p.ang, wall: i + 1 }); mm += p.len; });
      solo += pack(c.pieces.map(function (p) { return { len: p.len, ang: p.ang, wall: i + 1 }; }), rod).length;
    });
    var bins = pack(all, rod);
    bins.forEach(function (b) {
      var ws = {}, n = 0;
      b.items.forEach(function (x) { if (!ws[x.wall]) { ws[x.wall] = 1; n++; } });
      if (n > 1) { shared++; }
    });
    return { per: per, bins: bins, rods: bins.length, frames: frames, meters: mm / 100, pieces: all.length, rod: rod, shared: shared, solo: solo, walls: S.walls.length, split: mode };
  }
  /* כל אורכי הצלעות שארוכות ממוט, בלי כפילויות */
  function longLens(S) {
    var max = rodOf(S) - 0.5, seen = {}, out = [];
    function add(L) { var k = cm(L); if (L > max && !seen[k]) { seen[k] = 1; out.push(k); } }
    S.walls.forEach(function (w) {
      var g = geoOf(w);
      g.r.forEach(function (r) { add(r.w); add(r.h); });
      g.l.forEach(function (l) { add(Math.sqrt(Math.pow(l.x2 - l.x1, 2) + Math.pow(l.y2 - l.y1, 2))); });
    });
    return out;
  }
  /*
   * בוחר לכל אורך צלע ארוכה את שיטת החלוקה (שווה או חכמה) כך שסך המוטות יהיה הכי קטן.
   * עד 6 אורכים שונים בודק את כל הצירופים; מעבר לזה משווה "הכל שווה" מול "הכל חכם".
   * בתיקו - חלקים שווים (תפרים סימטריים). לכן התוצאה אף פעם לא גרועה מהשיטה הישנה.
   */
  function calcAll(S) {
    var eq = calcMode(S, 'eq'), keys = longLens(S), best = eq, bestSmart = 0, combos, c, i, map, n, t;
    if (!keys.length) { eq.eqRods = eq.rods; eq.splitSaved = 0; return eq; }
    if (keys.length <= 6) {
      combos = 1 << keys.length;
      for (c = 1; c < combos; c++) {
        map = {}; n = 0;
        for (i = 0; i < keys.length; i++) { if (c & (1 << i)) { map[keys[i]] = 'smart'; n++; } }
        t = calcMode(S, map);
        if (t.rods < best.rods || (t.rods === best.rods && best !== eq && n < bestSmart)) { best = t; bestSmart = n; }
      }
    } else {
      t = calcMode(S, 'smart');
      if (t.rods < eq.rods) { best = t; }
    }
    best.eqRods = eq.rods;
    best.splitSaved = eq.rods - best.rods;
    return best;
  }

  /* ================= מוצרים נלווים ================= */
  function kitQty(it, rods) {
    if (it.per) { return Math.max(1, Math.ceil(rods / it.per)); }
    return it.qty || 1;
  }
  /* בסיס הדגם: המספר שלפני המקף (401-2 → 401). בשופיפיי מעדיפים את bpk.frame_group אם מולא */
  function baseOf(p) {
    if (!p) { return ''; }
    if (p.group) { return String(p.group); }
    return String(p.model || '').split('-')[0];
  }
  function matchCorners(S, C) {
    var base = baseOf(S.mold);
    if (!base) { return []; }
    return C.corners.filter(function (c) { return baseOf(c) === base; });
  }
  function kitBySlug(C, slug) { return C.kits.filter(function (k) { return k.slug === slug; })[0] || null; }

  /* ================= פירוט להזמנה ================= */
  function cutSheet(S, mode) {
    var rod = rodOf(S), agg = {}, order = [];
    S.walls.forEach(function (w) {
      wallCalc(w, rod, mode).pieces.forEach(function (p) {
        var k = cm(p.len) + '|' + p.ang;
        if (!agg[k]) { agg[k] = { len: p.len, ang: p.ang, n: 0 }; order.push(k); }
        agg[k].n++;
      });
    });
    order.sort(function (a, b) { return agg[b].len - agg[a].len; });
    return order.map(function (k) { return agg[k]; });
  }
  function frameSizes(geo, sep) {
    var sizes = {};
    geo.r.forEach(function (r) { var k = '‎' + cm(r.w) + sep + cm(r.h); sizes[k] = (sizes[k] || 0) + 1; });
    return sizes;
  }
  function wallNote(S, w, i) {
    var c = wallCalc(w, rodOf(S)), def = LAYMAP[w.lay] || LAY[0], sizes = frameSizes(c.geo, 'x');
    var sz = Object.keys(sizes).map(function (k) { return sizes[k] + ' יח\' ' + k; }).join(', ');
    var mm = 0; c.pieces.forEach(function (p) { mm += p.len; });
    return 'קיר ' + (i + 1) + ': ' + cm(w.W) + 'x' + cm(w.H) + ' ס"מ | פריסה: ' + def.n +
      (c.geo.r.length ? ' | מסגרות: ' + c.geo.r.length + ' (' + sz + ' ס"מ)' : '') +
      (c.geo.l.length ? ' | פסים: ' + c.geo.l.length : '') +
      ' | מטר רץ: ' + cm(mm / 100);
  }
  function fullNote(S, t) {
    var L = ['דגם: ' + (S.mold ? S.mold.name : '')];
    S.walls.forEach(function (w, i) { L.push(wallNote(S, w, i)); });
    L.push('סה"כ ' + t.frames + ' מסגרות, ' + cm(t.meters) + ' מטר רץ, ' + t.rods + ' מוטות של ' + (t.rod / 100) + ' מטר');
    return L.join('\n');
  }
  function cutNote(S, t) {
    var L = ['רשימת חיתוך - דגם: ' + (S.mold ? S.mold.name : ''), 'אורך מוט: ' + (t.rod / 100) + ' מטר | סה"כ מוטות: ' + t.rods];
    S.walls.forEach(function (w, i) { L.push(wallNote(S, w, i)); });
    L.push('--- חיתוכים ---');
    cutSheet(S, t.split).forEach(function (c) { L.push(c.n + ' יח\' באורך ' + cm(c.len) + ' ס"מ, זווית ' + c.ang); });
    L.push('--- חלוקה למוטות ---');
    t.bins.forEach(function (b, i) {
      L.push('מוט ' + (i + 1) + ': ' + binTxt(b, t.walls > 1) + ' (נותר ' + cm(Math.max(0, b.rem)) + ' ס"מ)');
    });
    return L.join('\n');
  }

  /* רשימת הקנייה: אותו סדר ואותן כמויות כמו באתר הישן. id = מזהה הווריאנט בשופיפיי */
  function buildItems(S, C, t) {
    var items = [];
    if (!S.mold || !t.rods) { return items; }
    items.push({ id: S.mold.id, qty: t.rods, note: fullNote(S, t) });
    if (S.cut && C.cut) { items.push({ id: C.cut.id, qty: t.rods, note: cutNote(S, t) }); }
    if (S.kit) {
      var k = kitBySlug(C, S.kit);
      if (k) { k.items.forEach(function (it) { items.push({ id: it.id, qty: kitQty(it, t.rods) }); }); }
    }
    if (S.corn && S.cornId && t.frames) { items.push({ id: S.cornId, qty: t.frames * 4, note: '4 פינות לכל אחת מ-' + t.frames + ' המסגרות' }); }
    return items;
  }
  function totals(S, C, t) {
    var r = { mold: 0, cut: 0, kit: 0, corn: 0, total: 0 };
    if (!S.mold) { return r; }
    r.mold = S.mold.price * t.rods;
    r.cut = (S.cut && C.cut) ? C.cut.price * t.rods : 0;
    if (S.kit) {
      var k = kitBySlug(C, S.kit);
      if (k) { k.items.forEach(function (it) { r.kit += kitQty(it, t.rods) * it.price; }); }
    }
    if (S.corn && S.cornId) {
      var co = matchCorners(S, C).filter(function (c) { return c.id === S.cornId; })[0];
      if (co) { r.corn = co.price * t.frames * 4; }
    }
    r.total = r.mold + r.cut + r.kit + r.corn;
    return r;
  }

  /* ================= ציור ================= */
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function drawSVG(W, H, geo, prof, labels) {
    var p = prof || 4, pad = labels ? 26 : 2, o = '', vb = (-pad) + ' ' + (-pad) + ' ' + (W + 2 * pad) + ' ' + (H + 2 * pad);
    var Y = function (y, h) { return H - y - (h || 0); };
    o += '<svg viewBox="' + vb + '" width="' + (W + 2 * pad) + '" height="' + (H + 2 * pad) + '" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="סקיצת פריסה">';
    o += '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="#f4f0e8" stroke="#cfc4ae" stroke-width="' + (W / 300) + '"/>';
    geo.l.forEach(function (l) {
      o += '<line x1="' + l.x1 + '" y1="' + Y(l.y1) + '" x2="' + l.x2 + '" y2="' + Y(l.y2) + '" stroke="#a4894f" stroke-width="' + p + '" stroke-linecap="butt" opacity=".92"/>';
    });
    geo.r.forEach(function (r) {
      o += '<rect x="' + r.x + '" y="' + Y(r.y, r.h) + '" width="' + r.w + '" height="' + r.h + '" fill="#fffdf8" stroke="#a4894f" stroke-width="' + p + '"/>';
      o += '<rect x="' + (r.x + p / 2) + '" y="' + (Y(r.y, r.h) + p / 2) + '" width="' + Math.max(0, r.w - p) + '" height="' + Math.max(0, r.h - p) + '" fill="none" stroke="#e6dcc6" stroke-width="' + (p / 6) + '"/>';
    });
    if (labels && geo.r.length) {
      var r0 = geo.r[0], fs = Math.max(W, H) / 26;
      o += '<text x="' + (r0.x + r0.w / 2) + '" y="' + (Y(r0.y, r0.h) + r0.h / 2 + fs / 3) + '" font-size="' + fs + '" fill="#8c7340" text-anchor="middle" font-family="Arial">‎' + cm(r0.w) + ' × ' + cm(r0.h) + '</text>';
      o += '<text x="' + (W / 2) + '" y="' + (H + pad * 0.72) + '" font-size="' + fs + '" fill="#7a746a" text-anchor="middle" font-family="Arial">רוחב הקיר ' + cm(W) + ' ס"מ</text>';
      o += '<text x="' + (-pad * 0.35) + '" y="' + (H / 2) + '" font-size="' + fs + '" fill="#7a746a" text-anchor="middle" font-family="Arial" transform="rotate(-90 ' + (-pad * 0.35) + ' ' + (H / 2) + ')">גובה ' + cm(H) + ' ס"מ</text>';
    }
    o += '</svg>';
    return o;
  }

  var api = {
    KERF: KERF, LAY: LAY, LAYMAP: LAYMAP, FLD: FLD, newWall: newWall,
    cm: cm, esc: esc, geoOf: geoOf, wallCalc: wallCalc, pack: pack, calcAll: calcAll,
    kitQty: kitQty, baseOf: baseOf, matchCorners: matchCorners, kitBySlug: kitBySlug,
    cutSheet: cutSheet, frameSizes: frameSizes, binTxt: binTxt, fullNote: fullNote, cutNote: cutNote,
    buildItems: buildItems, totals: totals, drawSVG: drawSVG
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; } else { root.BPFrameEngine = api; }
})(typeof window !== 'undefined' ? window : this);
